// extracted by mini-css-extract-plugin
export default {"cover-spin":"Spinner_cover-spin__keTq0","spin":"Spinner_spin__y+g18"};